/**
 * CTASection Component
 *
 * Simple call-to-action section:
 * - Title (TextBlock)
 * - Subtitle or Text (HeadingBlock or QuillText)
 * - CTAButton (ButtonLink)
 *
 * Styling uses Bootstrap utility class props consistent with other sections.
 */
import React from "react";
import { filterClass } from "../../utils/class-utils";
import { getHorizontalContentAlign, getSectionBlockAlignClass } from "../utils/content-alignment";
import type { CTASectionProps } from "../types";

export function CTASection(props: CTASectionProps) {
  const {
    Title,
    SubtitleOrText,
    CTAButton,
    paddingYClass = "py-section-md",
    innerPaddingYClass = "no-class",
    innerBgClass = "no-class",
    bgClass = "no-class",
    contentAlignClass = "no-class",
  } = props;

  const inheritedContentAlign = getHorizontalContentAlign(contentAlignClass) ?? "center";

  const sectionClasses = [
    bgClass,
    filterClass(paddingYClass),
  ]
    .map(filterClass)
    .filter(Boolean)
    .join(" ");

  const innerwrapClasses = [
    filterClass(innerPaddingYClass),
    filterClass(innerBgClass),
  ]
    .filter(Boolean)
    .join(" ");

  /**
   * ===== CLASSES (frontend can edit here) =====
   */
  const classes = {
    section: ["section section-cta", sectionClasses].filter(Boolean).join(" ").trim(),
    container: "container-xl",
    innerwrap: ["d-flex flex-column", getSectionBlockAlignClass(contentAlignClass), innerwrapClasses]
      .filter(Boolean)
      .join(" "),
    titleWrap: "w-100 component-item",
    subtitleWrap: "w-100 component-item mt-2",
    ctaWrap: "w-100 component-item mt-4",
  };

  return (
    <section className={classes.section || undefined}>
      <div className={classes.container || undefined}>
        <div className={classes.innerwrap}>
          {Title && (
            <div className={classes.titleWrap || undefined}>
              <Title.type {...Title.props} inheritedContentAlign={inheritedContentAlign} />
            </div>
          )}
          {SubtitleOrText && (
            <div className={classes.subtitleWrap}>
              <SubtitleOrText.type {...SubtitleOrText.props} inheritedContentAlign={inheritedContentAlign} />
            </div>
          )}
          {CTAButton && (
            <div className={classes.ctaWrap}>
              <CTAButton.type {...CTAButton.props} inheritedContentAlign={inheritedContentAlign} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default CTASection;


